import { useState, useEffect } from 'react'
import ButtonActive from '../../ui/ButtonActive'
import { UploadOutlined } from '@mui/icons-material'
import { Autocomplete, TextField } from '@mui/material'
import { Col, message, Upload } from "antd"
import { CSVTOJSON2, DateFrequency } from '../../../utils/commonFunctions'



export default function UploadCustomKPI({ UploadFilecheck, setUploadFileCheck, setUploadFileData, setUploadFileName, SelectedDateColumn, SelectedPredictColumn,  setSelectedPredictColumn, setSelectedDateColumn, setUploadDataFrequency }) {

    const [UploadFIleColumnsOptions, setUploadFIleColumnsOptions] = useState(null)
    const [fileData, setFileData] = useState(null)
    
    const renderInput = (params,Type) => (
        <TextField
              {...params}
              placeholder="Select..."
              label={Type}
              variant="outlined"
            />
    )

    const beforeUploadHandler = (file) => {
        const isCSV = file.name.split('.').pop().toLowerCase() === 'csv';
        const isLt5M = file.size / 1024 / 1024 < 5;

        setUploadFileName(file.name);
    
        if (!isCSV) {
            message.error("Only '.csv' files are allowed.");
            return Upload.LIST_IGNORE;
        }
    
        if (!isLt5M) {
            message.error(`File size is ${parseFloat(file.size / 1024 / 1024).toFixed(2)} MB. Please upload files ≤ 5MB.`);
            return Upload.LIST_IGNORE;
        }
    
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (e) => {
            const fileText = e.target.result;
            const headers = fileText.split(/\r?\n/)[0]
            .split(',')
            .map((x) => x.trim())
            .filter((x) => !!x);
        
            if (!headers || !headers?.length) {
                // Return error if no headers found
                message.error('No Data found in the uploaded CSV file.', 5);
                return;
            }
            
            const options = headers.map((header) => ({
                name: header,
                value: header,
            }));
            
            const jsonData = CSVTOJSON2(fileText);
            if (jsonData.length === 0) {
                message.error('No Data found in the uploaded CSV file.', 5);
                return;
            }
            if (jsonData.length <= 10) {
                message.error('Uploaded CSV file contains only few rows of Data. For Nowcasting analysis, Please upload data with minimum of 10 rows.', 5);
                return;
            }

            setUploadFileData(jsonData);    
            setFileData(jsonData);
            setUploadFIleColumnsOptions(options);
        };
        setUploadFileCheck(true)
    
        return false;
    };
    
    function parseDates(data, dateColumn) {
        return data
            .map(row => new Date(row[dateColumn]))
            .filter(date => !isNaN(date))
            .sort((a, b) => a - b);
    }

    function getDayDifferences(dates) {
        const diffs = [];

        for (let i = 1; i < dates.length; i++) {
            const diffMs = dates[i] - dates[i - 1];
            const diffDays = diffMs / (1000 * 60 * 60 * 24);
            diffs.push(Math.round(diffDays));
        }

        return diffs;
    }

    function getMostCommonDiff(diffs) {
        const freqMap = {};

        diffs.forEach(diff => {
            freqMap[diff] = (freqMap[diff] || 0) + 1;
        });

        return Number(
            Object.keys(freqMap).reduce((a, b) =>
                freqMap[a] > freqMap[b] ? a : b
            )
        );
    }


    
    useEffect(() => {
        if (SelectedDateColumn && SelectedDateColumn?.value) {
            const dates = parseDates(fileData, SelectedDateColumn.value);

            if (dates.length < 2) {
                return "unknown";
            }

            const diffs = getDayDifferences(dates);
            const commonDiff = getMostCommonDiff(diffs);
            const frequency = DateFrequency(commonDiff)
            
            setUploadDataFrequency(frequency)


        }
    }, [SelectedDateColumn]);


    return (
        <>
            <Col span={6} style={{ display: !UploadFilecheck&&'flex', alignItems:!UploadFilecheck&&'end',  padding:'0px 15px' }}>
                {!UploadFilecheck&&<div style={{ fontSize:'60px',opacity:'0.5' , fontWeight:10, padding:'0 25px 15px 0px' }}>/</div>}
                <Upload
                    name="file"
                    maxCount={1}
                    beforeUpload={beforeUploadHandler}
                    // onChange={handleUpload}
                    onRemove={()=>{
                        setUploadFileCheck(false)
                        setUploadFileData(null)
                        setUploadDataFrequency(null)
                        setSelectedDateColumn(null)
                        setSelectedPredictColumn(null)
                        setUploadFIleColumnsOptions(null)
                        setUploadFileName(null)
                    }}
                    style={{ width: "100%" }}
                >
                    <div>
                        <ButtonActive
                        component="span"
                        style={{ height: "53px",width: "100%", backgroundColor:"#dccb03", color:"black" }}
                        variant="contained"
                        size="large"
                        
                        startIcon={<UploadOutlined style={{ fontSize: 30 }} />}
                        >
                        Upload Custom KPI Data
                    </ButtonActive>
                    </div>
                </Upload>
            </Col>
            {UploadFilecheck&&<>
                    <Col span={6} style={{ padding:'0px 15px'}}>
                        <Autocomplete
                            options={UploadFIleColumnsOptions?.length ? UploadFIleColumnsOptions : []}
                            renderInput={(params)=>renderInput(params,'Date Column')}
                            getOptionLabel={(option) => option.name}
                            disableClearable
                            loading={!UploadFIleColumnsOptions?.length}
                            value={UploadFIleColumnsOptions?.includes(SelectedDateColumn)?SelectedDateColumn:null}
                            onChange={(_,newValue)=>{setSelectedDateColumn(newValue)}}
                            fullWidth
                            style={{paddingRight: 5}}
                            />
                    </Col>
                    <Col span={6} style={{ padding:'0px 15px'}}>
                        <Autocomplete
                            options={UploadFIleColumnsOptions?.length ? UploadFIleColumnsOptions.filter(Item=>Item.name !== SelectedDateColumn?.name) : []}
                            renderInput={(params)=>renderInput(params,'Predict Column')}
                            getOptionLabel={(option) => option.name}
                            disableClearable
                            disabled={!SelectedDateColumn}
                            loading={!UploadFIleColumnsOptions?.length}
                            value={UploadFIleColumnsOptions?.includes(SelectedPredictColumn)?SelectedPredictColumn:null}
                            onChange={(_,newValue)=>{setSelectedPredictColumn(newValue)}}
                            fullWidth
                            style={{paddingRight: 5}}
                            />
                    </Col>
                </>}
        </>
    )
}